import { Viewer as ViewerClass, checkWebGPUAvailability } from '@cgtrader/cgt-viewer'

function hideLoader(canvas) {
  const loader = canvas?.parentElement?.querySelector('.embed__three-d-studio-loader')
  if (loader) loader.classList.add('embed__three-d-studio-loader--hidden')
}

export async function initThreeDStudioViewer(canvas) {
  const modelUrl = canvas?.dataset?.modelUrl
  if (!canvas || !modelUrl) return null

  const environmentUrl = canvas.dataset.environmentUrl

  try {
    const gpu = await checkWebGPUAvailability()
    // `autoStart: false` lets us hide the gizmo and grid before the first
    // frame is rendered, avoiding the brief flicker that would otherwise show.
    const viewer = await ViewerClass.create(canvas, {
      dracoPath: '/draco/gltf/',
      backend: gpu.available ? 'webgpu' : 'webgl',
      autoStart: false,
    })

    viewer.setViewportGizmoSettings({ visible: false })
    viewer.setGridSettings({ visible: false })
    viewer.setSceneSettings({ envColor: 0x4a4a4a })
    // Without an HDRI the ambient + directional fallback renders metallic materials almost
    // black, so the embed loads the studio's default surrounding as an unshown environment map.
    // Only showBackground is set here: `enabled` defaults to false and loadEnvironment flips it
    // on success. Setting it up front would make the viewer load its current preset, which is ""
    // for a viewer created without environmentPresets - a fetch of this page parsed as HDR.
    viewer.setEnvironmentSettings({ showBackground: false })
    viewer.start()

    await Promise.all([
      viewer.loadModel(modelUrl),
      environmentUrl ? viewer.loadEnvironment(environmentUrl).catch(() => {}) : Promise.resolve(),
    ])
    hideLoader(canvas)
    return viewer
  } catch (error) {
    console.error('Failed to initialize 3D Studio embed viewer:', error)
    hideLoader(canvas)
    return null
  }
}
